import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { EVENT_PERSON_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function insert_event_person(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(EVENT_PERSON_CACHE_FIELDS, cache);
}
